var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V341.997H0V-0.00683594Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.625 341.989L256.5 167.272L283.379 341.989H384.625ZM133.826 -0.00976562L256.5 167.272L230.764 -0.00976562H133.826ZM229.619 341.989L256.5 167.272L128.374 341.989H229.619ZM0 -0.00976562V127.809L256.5 167.272L28.3883 -0.00976562H0ZM0 341.989H18.2476L256.5 167.272L0 206.733V341.989ZM256.5 167.272L513 127.809V-0.00976562H484.614L256.5 167.272ZM282.236 -0.00976562L256.5 167.272L379.173 -0.00976562H282.236ZM513 341.989V206.734L256.5 167.272L494.751 341.989H513Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 226.751C289.347 226.751 315.975 200.123 315.975 167.276C315.975 134.429 289.347 107.801 256.5 107.801C223.653 107.801 197.025 134.429 197.025 167.276C197.025 200.123 223.653 226.751 256.5 226.751Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 211.885C281.137 211.885 301.109 191.913 301.109 167.276C301.109 142.64 281.137 122.667 256.5 122.667C231.863 122.667 211.891 142.64 211.891 167.276C211.891 191.913 231.863 211.885 256.5 211.885Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/MK.d5c07bbfb6469b45c6da66c0d86b03b2.svg";
export { ForwardRef as ReactComponent };